<template>
  <div class="comp-list">
    <el-input placeholder="请选择客户" v-model="name" disabled>
      <el-button slot="append" @click="showCustList">选择</el-button>
    </el-input>
    <el-dialog title="选择客户" :visible.sync="visible" width="700px" append-to-body :before-close="close">
      <div class="operate-header">
        <el-form :inline="true" @submit.native.prevent class="demo-form-inline" label-suffix="：">
          <el-form-item label="客户名称">
            <el-input v-model.trim="customerName" @keyup.enter.native.prevent="currentChange(1)" placeholder="请输入客户名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="currentChange(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="list-table">
        <new-table ref="table" :data="tableData" :columns="columns" :pages="pages" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import NewTable from "@/components/new-table";
import { CustomerApis } from "@/apis/customer";

export default {
  name: "select-customer",
  components: { NewTable },
  props: {
    name: String,
    isReport: { type: Number, default: -1 },
  },
  data() {
    return {
      visible: false,
      customerName: "",
      tableData: [],
      columns: [
        { label: "客户名称", prop: "customerName" },
        { label: "联系人", prop: "linkName" },
        { label: "手机", prop: "linkPhone" },
        {
          label: "操作",
          width: "60px",
          render: (h, { row }) => {
            return (
              <el-button type="text" class="btn-blue" onClick={() => this.selectRow(row)}>
                选择
              </el-button>
            );
          },
        },
      ],
      pages: {
        props: {
          pageSize: 20,
          currentPage: 1,
          total: 0,
        },
        on: {
          "current-change": (p) => {
            this.currentChange(p);
          },
          "size-change": this.sizeChange,
        },
      },
    };
  },
  methods: {
    async getData() {
      const params = {
        customerName: this.customerName,
        pageIndex: this.pages.props.currentPage,
        pageSize: this.pages.props.pageSize,
        isReport: this.isReport,
      };
      const res = await CustomerApis.getCustomerList(params);
      res.data.forEach((i) => {
        const cheif = i.linkUserList.find((l) => l.isChief) || i.linkUserList[0];
        if (cheif) {
          i.linkName = cheif.linkName;
          i.linkPhone = cheif.linkPhone;
        }
      });
      this.tableData = res.data;
      this.pages.props.total = res.dataCount;
    },
    showCustList() {
      this.getData();
      this.visible = true;
    },
    currentChange(p) {
      this.pages.props.currentPage = p;
      this.getData();
    },
    sizeChange(size) {
      this.pages.props.pageSize = size;
      this.currentChange(1);
    },
    selectRow(row) {
      this.$emit("confirm", row);
      this.visible = false;
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.select-input {
  cursor: pointer;
}
.list-table {
  height: 300px;
}
</style>
